export default "__VITE_ASSET__DoVF5w0e__"